module.exports = __webpack_public_path__ + "static/media/dni-tramite.b412b9c2.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/montemar-adelantos/img/dni-tramite.png
 ** module id = 1360
 ** module chunks = 0
 **/